import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import React from "react";
import { AppSidebar } from "./AppSidebar";
import { SiteHeader } from "./SiteHeader";

interface AppLayoutProps {
  children: React.ReactNode;
  headerTitle?: string;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  headerTitle,
}) => (
  <SidebarProvider>
    <AppSidebar variant="inset" />
    <SidebarInset className="flex flex-col min-h-screen">
      <SiteHeader className="sticky top-0 z-10" title={headerTitle} />
      <div className="flex-1">{children}</div>
    </SidebarInset>
  </SidebarProvider>
);
